import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

import { Question } from '@neo.tax/shared';

import { QuestionWithChildQuestions } from './company-info.types';

const sortByDisplayOrder = <T extends { displayOrder: number }>(objects: T[]): T[] =>
  sortBy(objects, (o) => o.displayOrder);

export const prepareQuestions = (questions: Question[]): QuestionWithChildQuestions[] => {
  // Make our own copy to mutate. This makes it easier to handle nested questions.
  const freshQuestions = questions.map((question) => ({ ...question }));
  const questionsByParentChoiceId = groupBy(freshQuestions, (question) => question.parentQuestionChoice?.id);

  freshQuestions.forEach((question) => {
    question.questionChoices &&= sortByDisplayOrder(
      question.questionChoices.map((choice) => ({
        ...choice,
        childQuestions: questionsByParentChoiceId[choice.id],
      })),
    );
  });

  return sortByDisplayOrder(freshQuestions.filter((question) => !question.parentQuestionChoice));
};
